import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import smoothscroll from 'smoothscroll-polyfill';

import './index.css';
import H5 from './router/h5';
import { isMobile, initLocalToken, supportLegacyBrowsers } from './utils/common';

smoothscroll.polyfill();
initLocalToken()
supportLegacyBrowsers()
// 3225
// setCookie('u_token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjayI6IlRPS0VOIiwiZXhwIjoyMDE2MjYxNjAzLCJpYXQiOjE3MDg2Nzc2MDMsIm5iZiI6MTcwODY3NzQ4Mywic3lzdHlwZSI6IndlYiIsInVzZXJfaWQiOiIzNjMxNjc1OSJ9.W3LU1GNxFPqj1tMDK3ZGfI54NEJO9QDLitQVHnYxRnY')
// dskce034
// setCookie('u_token', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjayI6IlRPS0VOIiwiZXhwIjoyMDE2MjU2OTA3LCJpYXQiOjE3MDg2NzI5MDcsIm5iZiI6MTcwODY3Mjc4Nywic3lzdHlwZSI6IndlYiIsInVzZXJfaWQiOiIzNzQ5NjYzOSJ9.sbuY1nU4E3wrGiBwko75rgdAICVlyUqKLKkUEzP-Em4')

if (isMobile()) {
  require('./utils/flexible');
  ReactDOM.render(<H5 />, document.getElementById('root'));
} else {
  ReactDOM.render(<H5 />, document.getElementById('root'));
}

